<script setup>
import {computed, defineEmits, defineProps, ref} from "vue";
import {game} from "@/utils/config";

const type = computed(() => game.mos)
const props = defineProps({
  product: {
    type: Object,
    default() {
      return {}
    }
  },
  changeProduct: {
    type: Boolean,
    default() {
      return false
    }
  },
  account: {
    type: Object,
    default() {
      return {}
    }
  },
  payLoading: {
    type: Boolean,
    default: () => {
      return false
    }
  }
})
const rechargeAccount = ref('')
const changeProduct = computed(() => props.changeProduct)
const number = ref(1)
const emit = defineEmits(['pay'])
const maxNumber = computed(() => {
  let number = 50;
  if (props.account && props.account.balance_miles) {
    number = Math.floor(parseFloat(props.account.balance_miles) / parseFloat(props.product?.mileTypes?.scal?.total))
  }
  return number > 50 ? 50 : number
})
</script>

<template>
  <el-drawer v-model="changeProduct" direction="btt" style="border-radius: 12px 12px 0 0" size="540"
             :show-close="false" v-if="changeProduct" :style="type.style">
    <template #header>
      <div class="product-info-header">
        <div class="product-info-img">
          <el-image :src="type.productImgAvatar"/>
        </div>

        <div class="product-info-data">
          <h4>{{ product.goods_name }}</h4>
          <div>{{ type.coupon_type }}</div>
          <div class="product-info-money">
            <b>{{ props.product.mileTypes.scal.total }}</b>里程
          </div>
        </div>
      </div>
    </template>
    <div class="tips">
      兑换成功后系统将自动注册该手机号为茉酸奶会员并完成充值，<span class="required">请确保手机号填写正确</span>，因手机号填写错误造成的损失由会员本人承担。
    </div>
    <el-card style="margin-bottom: 20px">
      <div class="user-account-data">
        <div class="user-account-data-title">
          {{ type.input_tag }}
        </div>
        <div class="input">
          <!--          <div class="tips">{{ type.tips }}</div>-->
          <el-input :placeholder="type.placeholder" clearable class="product-inputs"
                    v-model="rechargeAccount"/>
        </div>
      </div>
    </el-card>
    <el-card style="margin-bottom: 20px">
      <div class="user-account-data">
        <div class="user-account-data-title">
          兑换数量
        </div>
        <div class="input">
          <el-input-number v-model="number" :min="1" :max="maxNumber"/>
        </div>
      </div>
    </el-card>
    <el-card style="margin-bottom: 20px">
      <div class="user-account-miles">
        <div class="user-account-data-jingle">
          可用里程
        </div>
        <div class="miles">
          {{ props.account.balance_miles }}
        </div>
      </div>
      <div class="user-account-miles">
        <div class="user-account-data-jingle">
          支付里程
        </div>
        <div class="miles">
          {{ props.product.mileTypes.scal.total * number }}
        </div>
      </div>
    </el-card>
    <div class="product-recharge-btn">
      <el-button type="danger" round size="large"
                 :disabled="parseInt(props.product.mileTypes.scal.total) > props.account.balance_miles || !type.isIos"
                 :loading="props.payLoading"
                 @click="emit('pay',{account:rechargeAccount,number})">立即兑换
      </el-button>
    </div>
  </el-drawer>
</template>

<style scoped lang="less">

.product-info-header {
  display: flex;
  align-items: center;

  .product-info-img {
    width: 80px;
    padding: 10px;
    text-align: center;
    margin-right: 5px;
    background: #00502B;
    border-radius: 8px;
  }

  .product-info-data {
    margin-left: 10px;
    line-height: 25px;

    .product-info-money {
      margin-top: 10px;

      b {
        font-size: 1.75rem;
        color: #E31D1A;
      }
    }
  }
}

.tips {
  margin: -5px auto 15px;
  line-height: 1.5;
  font-size: .8rem;
  color: var(--el-color-info);
}

.user-account-data {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .tips {
    font-size: .65rem;
    color: #FF8409;
    white-space: nowrap;
    text-align: right;
  }

  .user-account-data-title {
    font-size: .8rem;
    color: var(--view-product-user-pay-account-tips);
    border: var(--view-product-user-pay-account-tips-border);
    padding: 5px;
    border-radius: 3px;
  }

  .input {
    //width: 72%;
    //flex-basis: 72%;
  }
}

.user-account-miles {
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 35px;

  & + .user-account-miles {
    border-top: var(--el-border);
  }
}

.product-recharge-btn {
  width: 220px;
  margin: auto;

  .el-button {
    width: 100%;

  }
}
</style>
